/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* eslint-disable */
import type { ActionDataStructure } from './ActionDataStructure';
import type { NaturalLanguageStringStructure } from './NaturalLanguageStringStructure';
export type ManualAction = {
    actionData?: Array<ActionDataStructure>;
    actionStatus?: ManualAction.actionStatus;
    description?: NaturalLanguageStringStructure;
};
export namespace ManualAction {
    export enum actionStatus {
        OPEN = 'OPEN',
        PUBLISHED = 'PUBLISHED',
        CLOSED = 'CLOSED',
    }
}

